<template>
  <div v-if="params.badgePractice" class="flex flex-col justify-center h-full leading-tight gap-0.5">
    <span v-if="secondary" class="sensitive text-xs text-gray-900 truncate pl-[7px]">{{ titleCase(secondary) }}</span>
    <span v-if="primary" class="self-start max-w-full truncate px-1.5 py-0.5 border border-gray-300 bg-gray-100 rounded text-xs text-gray-900">
      <span class="sensitive">{{ titleCase(primary) }}</span>
    </span>
    <span v-if="!primary && !secondary" class="text-sm text-gray-900">-</span>
  </div>
  <div v-else class="flex flex-col justify-center h-full leading-tight">
    <span class="sensitive text-sm text-gray-900 truncate">{{ titleCase(primary) || '-' }}</span>
    <span v-if="secondary" class="sensitive text-xs text-gray-500 truncate">{{ titleCase(secondary) }}</span>
  </div>
</template>

<script>
export default {
  name: 'Quality_EntityCell',
  props: ['params'],
  computed: {
    primary() {
      return this.params.data?.practice_name;
    },
    secondary() {
      return this.params.data?.provider_name;
    }
  },
  methods: {
    titleCase(str) {
      if (!str) return str;
      const keep = new Set(['LLC', 'PLLC', 'PC', 'MD', 'DO', 'NP', 'PA', 'RN', 'DPM', 'OD', 'II', 'III', 'IV']);
      return str.split(/\s+/).map(w => {
        const clean = w.replace(/[,.]$/, '');
        if (keep.has(clean.toUpperCase())) return w.toUpperCase();
        return w.toLowerCase().replace(/^\w/, c => c.toUpperCase());
      }).join(' ');
    }
  }
};
</script>
